/**
 * Parse deck list text (e.g. "4xOP13-016\n1xOP13-002" or "1 x OP13-002").
 * Returns [{ cardNumber, quantity }] with cardNumber uppercase (e.g. "OP13-016").
 */
export function parseDeckList(text) {
  if (!text || typeof text !== 'string') return [];
  const normalized = text
    .replace(/[\r\n\t]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  const regex = /(\d+)\s*x\s*([A-Z0-9]+-\d+)/gi;
  const matches = [...normalized.matchAll(regex)];
  const entries = [];
  for (const m of matches) {
    const quantity = parseInt(m[1], 10);
    const cardNumber = m[2].toUpperCase();
    if (quantity > 0 && cardNumber) {
      entries.push({ cardNumber, quantity });
    }
  }
  return entries;
}
